import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  CommonModule, LocationStrategy,
  PathLocationStrategy
} from '@angular/common';
import { NgModule ,CUSTOM_ELEMENTS_SCHEMA, isDevMode} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient,HTTP_INTERCEPTORS } from '@angular/common/http';
import { Routes, RouterModule, Router } from '@angular/router';
import { NgbDropdownModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FullComponent } from './layouts/full/full.component';
import { NavigationComponent } from './shared/header/navigation.component';
import { SidebarComponent } from './shared/sidebar/sidebar.component';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SpinnerComponent } from './shared/spinner.component';
import { LoginComponent } from './login/login.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { AuthService } from '../app/services/auth/auth.service';
import { AuthGuard } from '../app/services/auth/auth.guard';
import { AuthInterceptor } from '../app/services/auth/auth.interceptor';
import { ToastComponent } from './toast/toast.component';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { LoaderComponent } from './shared/loader/loader.component';
import { AuditModule } from './audit/audit.module';
import { AllotAuditorModule } from './allot-auditor/allot-auditor.module';

import { BylawsModule } from './bylaws/bylaws.module';
import { DatePipe } from '@angular/common';
import { ForgotpasswordComponent } from './login/forgotpassword/forgotpassword.component';
import { FooterModule } from './front/footer/footer.module';
import { AccessDeniedComponent } from './login/access-denied/access-denied.component';
import { CooperativeSocietiesComponent } from './cooperative-societies/cooperative-societies.component';
import { UserprofileComponent } from './userprofile/userprofile.component';
import { NgxUiLoaderModule } from 'ngx-ui-loader';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { RegistrationComponent } from './login/registration/registration.component';
import { HighchartsChartComponent, HighchartsChartModule } from 'highcharts-angular';
// import { provideHighcharts } from 'h/ighcharts-angular';

// import { ViewSocietyDetailComponent } from './shared/view-society-detail/view-society-detail.component';
// import { LiquidationModule } from './liquidation/liquidation/liquidation.module';
import { Chart } from 'chart.js';
import {
  CategoryScale,
  LinearScale,
  BarElement,
  BarController,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { ReportsModule } from './reports/reports.module';
import { RcsUpdateComponent } from './clone/rcs-update/rcs-update.component';

// ✅ Register all required pieces
Chart.register(
  CategoryScale,
  LinearScale,
  BarElement,
  BarController,
  Title,
  Tooltip,
  Legend
);

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    AppComponent,
    SpinnerComponent,
    LoginComponent,
    ToastComponent,
    ForgotpasswordComponent,
    AccessDeniedComponent,
    UserprofileComponent,
    CooperativeSocietiesComponent,
    RegistrationComponent,
    RcsUpdateComponent
  
    





  ],
  imports: [
    CommonModule,
    RouterModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgbModule,
    // RouterModule.forRoot([], { useHash: false }),
    AppRoutingModule,
    FullComponent,
    NavigationComponent,
    SidebarComponent,
    NgxDatatableModule,
    NgbToastModule,
    AuditModule,
    AllotAuditorModule,
    NgbDropdownModule,
    
    BylawsModule,

       FooterModule,
       NgxUiLoaderModule,
       StoreModule.forRoot({}, {}),
       EffectsModule.forRoot([]),
       StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: !isDevMode() }),
       StoreRouterConnectingModule.forRoot(),
       HighchartsChartModule,
       ReportsModule



  ],
  exports: [RouterModule,SpinnerComponent],
  providers: [
    AuthService,
    AuthGuard,
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy
    },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptor,
    multi: true
  },
    DatePipe
  ],
  
  bootstrap: [AppComponent]
})
export class AppModule {
 

 }
